<script setup>
import { ref, computed } from 'vue'
import { WindowsOutlined, LeftCircleOutlined, RightCircleOutlined, DownCircleOutlined } from '@ant-design/icons-vue';
import { useDeviceStore } from '@/stores/device';
import Icon from '@/components/Icon.vue'
import ChooseLanguage from '@/components/ChooseLanguage.vue';

const deviceStore = useDeviceStore()
const isCollapsed = ref(false)
const visible = ref(false)
const checked1 = ref()

// 从 HTML 属性中获取当前主题设置
const getCurrentTheme = () => {
    let theme = document.documentElement.getAttribute('data-theme') || 'dark'
    return theme === 'dark' ? false : true
}

const currentThemeValue = ref(getCurrentTheme())

const currentTheme = computed(() => {
    return currentThemeValue.value === 'dark' ? false : false
})



const clickTheme = (event) => {
    // console.log('ecent', event)
    // const options = ['亮色模式', '暗色模式']
    let type = event ? 'light' : 'dark'
    currentThemeValue.value = event
    // 直接修改 HTML 的 data-theme 属性
    document.documentElement.setAttribute('data-theme', type)
    // 保存到 localStorage
    localStorage.setItem('theme', type)
}
</script>
<template>
    <div :class="['sidebar', isCollapsed ? 'collapsed' : '']">
        <header class="sider-header">
            <div class="sider-header-logo">
                <WindowsOutlined />
            </div>
        </header>
        <div @click="isCollapsed = !isCollapsed" class="siderbar-handle">
            <LeftCircleOutlined v-show="!isCollapsed" />
            <RightCircleOutlined v-show="isCollapsed" />
        </div>
        <div :class="['siderbar-content', isCollapsed ? 'collapsed' : '']">
            <div :class="['flex-list', isCollapsed ? 'collapsed' : '']">
                <div class="keyboard-section">
                    <div class="keyboard-bg">
                        <div class="relative-1">
                            <!-- <img src="../../assets/images/Kick75.webp" class="main-class" alt=""> -->
                        </div>
                    </div>
                    <div class="keyboard-info ">
                        <div>
                            <div class="mVmqcg"></div>
                            <div class="keyboard-name cimgxp CVMgUZ">{{ deviceStore.productName }}</div>
                        </div>
                        <!-- <a-tooltip>
                            <template #title><span class="firmware">{{ $t('common.firmware') +
                                deviceStore.lightData.firmware
                                    }}</span></template>
<Icon name="setting" :size="20" color="rgba(255, 255, 255, 0.32)"></Icon>
</a-tooltip> -->
                    </div>
                </div>
                <div class="onboard-section">
                    <div class="profile-list">
                        <span class="HEEUyn">{{ $t('common.onboard') }}</span>
                        <div
                            :class="['rKVPaR', deviceStore.lightData.keyboardType === 'M' ? 'active' : 'disabled', isCollapsed ? 'collapsed' : '']">
                            <span class="nav-button-badge">M1</span>
                            <div class="nav-button-content"><span
                                    class="sc-hvigdm sc-fhHczv bDNdxN kTbYFY nav-button-name">Mac</span>
                                <div class="nav-button-handle">

                                </div>
                            </div>
                        </div>
                        <div
                            :class="['rKVPaR', deviceStore.lightData.keyboardType === 'W' ? 'active' : 'disabled', isCollapsed ? 'collapsed' : '']">
                            <span class="nav-button-badge">M2</span>
                            <div class="nav-button-content"><span
                                    class="sc-hvigdm sc-fhHczv eZoCVx kTbYFY nav-button-name">Windows</span>
                                <div class="nav-button-handle">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="profile-list">
                        <span class="gdasrc">{{ $t('common.unapplied') }}</span>

                    </div>
                </div>
                <div class="siderbar-block">
                </div>
                <div class="siderbar-block">

                    <!-- <div class="rKVPaR">
                        <div @click="clickTheme" class="nav-button-content pointer">
                            <span class="sc-hvigdm sc-fhHczv bDNdxN kTbYFY ">{{
                                currentTheme
                                }}</span>
                            <div style="display: flex;">
                                <DownCircleOutlined />
                            </div>
                        </div>
                    </div> -->
                    <a-switch @click="clickTheme" v-model:checked="currentThemeValue"
                        :checked-children="$t('common.light')" :un-checked-children="$t('common.dark')" />
                </div>
                <footer class="siderbar-block">
                    <ChooseLanguage></ChooseLanguage>
                    <!-- <div class="sc-jJLAfE rKVPaR">
                        <div class="nav-button-icon"><svg class="icon-svg" aria-hidden="true" width="19.25925925925926"
                                height="19.25925925925926" style="fill: currentcolor; min-width: 19.2593px;">
                                <use xlink:href="#QuestionMarkBox"></use>
                            </svg></div>
                        <div class="nav-button-content"><span
                                class="sc-hvigdm sc-fhHczv bDNdxN kTbYFY nav-button-name">IO 手册</span></div>
                    </div> -->
                    <!-- <div class="sc-jJLAfE rKVPaR">
                        <div class="nav-button-icon"><svg class="icon-svg" aria-hidden="true" width="19.25925925925926"
                                height="19.25925925925926" style="fill: currentcolor; min-width: 19.2593px;">
                                <use xlink:href="#SettingGear"></use>
                            </svg></div>
                        <div class="nav-button-content"><span
                                class="sc-hvigdm sc-fhHczv bDNdxN kTbYFY nav-button-name">设置</span></div>
                    </div> -->
                </footer>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.language-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    a {
        padding: 8px 12px;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
            background-color: var(--button-white-xl);
        }
    }
}

.pointer {
    cursor: pointer;
}

.relative-1 {
    position: relative;
    width: 104px;
    height: 69.3333px;
}

.mVmqcg {
    display: flex;
    width: 0.375rem;
    height: 0.375rem;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 0.1425rem;
    position: relative;
    overflow: hidden;
    background: var(--theme-color);

    &::after {
        content: "";
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: linear-gradient(-180deg, rgba(225, 225, 225, 0.86), rgba(225, 225, 225, 0.16));
    }
}

.cimgxp {
    font-size: 0.75rem;
    font-weight: 700;
}

.CVMgUZ {
    color: var(--text-black-l-title);
    overflow: hidden;
    white-space: nowrap;
    text-transform: capitalize;
    line-height: normal;
    text-overflow: ellipsis;
}

.HEEUyn {
    display: inline-block;
    line-height: normal;
    color: var(--text-black-s-content);
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.0075rem
}

.rKVPaR.disabled {
    pointer-events: none;
    opacity: 0.32;
}

.rKVPaR.active {
    background: var(--button-black-l);
}



.kTbYFY {
    font-size: 0.75rem;
    font-weight: 700;
}

// .bDNdxN {
//     color: var(--text-black-l-title);
//     overflow: hidden;
//     white-space: nowrap;
//     text-transform: capitalize;
//     line-height: normal;
//     text-overflow: ellipsis;
//     font-size: 0.875rem;
//     font-weight: 900;
// }




.sider-header {
    gap: 0.5rem;
    border-radius: var(--border-radius-l);
    background: var(--box-nested-white-xl-max);
    clip-path: inset(0 round var(--border-radius-l));
    padding: 0.5rem 0.75rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
}

.sider-header-logo {
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.siderbar-handle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1.5rem;
    cursor: pointer;
    right: -0.9375rem;
}

.siderbar-content {
    height: 100%;
    width: 100%;
    flex: 1 0 0px;
}

.flex-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    gap: 0.5rem;
    height: 100%;

    .keyboard-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        padding: 0.5rem;
        gap: 0.5rem;
        border-radius: var(--border-radius-l);
        background: var(--box-nested-white-xl-max);
        clip-path: inset(0 round var(--border-radius-l));
        justify-content: center;
    }

    .onboard-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        padding: 0.5rem;
        border-radius: var(--border-radius-l);
        clip-path: inset(0 round var(--border-radius-l));
        gap: 1rem;
        flex: 1 0 0px;
        background: var(--button-white-xl);
    }

    .keyboard-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4.5rem;
        align-self: stretch;
        padding: 0.853125rem 2.375rem;
        border-radius: var(--border-radius-m);
        background: var(--button-black-xs-min);
        overflow: hidden;
    }

    .keyboard-info {
        display: flex;
        align-items: center;
        padding: 0rem 0.25rem;
        gap: 0.5rem;
        align-self: stretch;
        justify-content: space-between;

        svg {
            cursor: pointer;
        }

        &>div {
            display: flex;
            align-items: center;
        }

        &>div>div {
            margin-right: 10px;
        }
    }

    .main-class {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        object-fit: contain;
        z-index: 10;
    }

    .siderbar-block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        padding: 0.5rem;
        gap: 0.5rem;
        border-radius: var(--border-radius-l);
        background: var(--box-nested-white-xl-max);
        clip-path: inset(0 round var(--border-radius-l));
    }

}

.flex-list.collapsed .sidebar-right-keyboard-section,
.flex-list.collapsed .sidebar-right-keyboard-info,
.flex-list.collapsed .sidebar-right-profile-list,
.flex-list.collapsed .sidebar-right-profile-item {
    justify-content: center;
    align-items: center;
}

.firmware {
    display: inline-block;
    line-height: normal;
    color: var(--text-white-l-title);
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.0075rem;
}

.ant-switch {
    width: 80px;
}

.ant-switch .ant-switch-inner .ant-switch-inner-checked,
.ant-switch .ant-switch-inner .ant-switch-inner-unchecked {
    color: var(--text-white-l-title);
}
</style>